import { Invitation } from "../models/Invitation";
import api from "./api"; // custom axios instance

export const InvitationService = {
  async getInvitations(): Promise<Invitation[]> {
    const res = await api.get(`/api/v1/invitations`);
    return res.data?.data ?? [];
  },

  async createInvitation(invitation: Partial<Invitation>): Promise<string> {
    const res = await api.post("/api/v1/invitations", invitation);
    return res.data?.data?._id;
  },

  async updateInvitation(
    invitationId: string,
    invitationData: Partial<Omit<Invitation, "_id">>,
  ): Promise<void> {
    await api.patch(`/api/v1/invitations/${invitationId}`, invitationData);
  },

  async deleteInvitation(invitationId: string): Promise<void> {
    await api.delete(`/api/v1/invitations/${invitationId}`);
  },
};
